import Services from "lib/Services";
import ajaxHelper from "data/util/ajaxHelper";
import DevelopmentActions from "data/dev/DevelopmentActions";

const DevDataManager = {
    loadITManifest: () =>
        ajaxHelper(
            Services.loadITManifest(),
            {
                type: DevelopmentActions.IT_MANIFEST_LOADED,
            },
            {
                type: DevelopmentActions.IT_MANIFEST_ERROR,
            },
        ),
    loadMocksetManifest: () =>
        ajaxHelper(
            Services.loadMocksetManifest(),
            {
                type: DevelopmentActions.MOCKSET_MANIFEST_LOADED,
            },
            {
                type: DevelopmentActions.MOCKSET_MANIFEST_ERROR,
            },
        ),
};

export default DevDataManager;



// WEBPACK FOOTER //
// ./app/data/dev/DevDataManager.js